export function additionalInfo() {
    let $list = $(".list-additional-info");

    if ($list.length > 0) {
        $list.find('li').each(function () {
            let _this = $(this);
            _this.find('h4, .h4').click(function () {
                let _this = $(this);
                _this.parents('li').toggleClass('opened').find('p').slideToggle();
            });
        });
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/additionalInfo.js